import React from 'react';
export function SliderIndicator(props) {
    const { current = -1, total = 0, className, type, onClick, ...restProps } = props;
    if (type === 'number') {
        return (React.createElement("div", { className: `indicator-number${className || ''}`, ...restProps },
            current + 1,
            "/",
            total));
    }
    const dots = new Array(total).fill(1).map((_, index) => {
        return (React.createElement("div", { className: `indicator-dot ${index === current ? 'indicator-dot-active' : ''}`, onClick: () => onClick?.(index), key: `${index}` }));
    });
    return (React.createElement("div", { className: `${className || ''} cn-ui-m-slider-indicator `, ...restProps }, dots));
}
